import data from './data';
import date from './date';
import func from './func';
import img from './img';
import mp from './mp';
import navbar from './navbar';
import page from './page';
import style from './style';
import tabbar from './tabbar';
import url from './url';

export const commonUtils = {
  mp,
  url,
  img,
  data,
  page,
  tabbar,
  navbar,
  date,
  func,
  style,
};
